// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tab-common {
  padding: 0.25rem 0;
}

.custom-tab-section {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1rem;
}

.custom-tab-section:last-child {
  margin-bottom: 0;
}

.custom-tab-heading {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.75rem;
}

.custom-tab-common p {
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0 0 0.5rem;
}

.custom-tab-common p:last-child {
  margin-bottom: 0;
}

.custom-tab-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 1rem;
  align-items: start;
  margin-top: 0.5rem;
}

.custom-tab-legend {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.custom-tab-legend p {
  margin-bottom: 0.4rem;
}

.custom-tab-image-wrap {
  background: var(--bg-primary);
  border-radius: 8px;
  padding: 0.75rem;
  text-align: center;
}

.custom-tab-image {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}

.custom-tab-note {
  font-style: italic;
  color: var(--text-tertiary);
}

.custom-tab-warning {
  background: rgba(245, 158, 11, 0.1);
  border-left: 3px solid var(--warning);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin: 0.75rem 0;
}

.custom-tab-warning p {
  margin: 0;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.55;
}

@media (max-width: 640px) {
  .custom-tab-row {
    grid-template-columns: 1fr;
  }

  .custom-tab-section {
    padding: 1rem;
  }
}

/* BodySurf guide */
.bodysurf-list {
  margin: 0.5rem 0 0.75rem;
  padding-left: 1.25rem;
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
}

.bodysurf-list li {
  margin-bottom: 0.35rem;
}

.bodysurf-title-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.75rem;
  font-size: 0.9rem;
}

.bodysurf-title-table th,
.bodysurf-title-table td {
  padding: 0.4rem 0.6rem;
  text-align: left;
  border-bottom: 1px solid var(--border-primary);
  color: var(--text-secondary);
}

.bodysurf-title-table th {
  color: var(--text-primary);
  font-weight: 600;
}

.bodysurf-title-table tbody tr:last-child td {
  border-bottom: none;
}

.custom-tab-common .guide-inline-link {
  color: var(--accent-primary);
  text-decoration: underline;
  font-weight: 500;
}

.custom-tab-common .guide-inline-link:hover {
  color: var(--accent-hover);
}
`, "",{"version":3,"sources":["webpack://./src/components/customTabs/CustomTabCommon.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".custom-tab-common {\r\n  padding: 0.25rem 0;\r\n}\r\n\r\n.custom-tab-section {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 12px;\r\n  padding: 1.25rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.custom-tab-section:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-tab-heading {\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.75rem;\r\n}\r\n\r\n.custom-tab-common p {\r\n  color: var(--text-secondary);\r\n  font-size: 0.95rem;\r\n  line-height: 1.6;\r\n  margin: 0 0 0.5rem;\r\n}\r\n\r\n.custom-tab-common p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-tab-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1.2fr;\r\n  gap: 1rem;\r\n  align-items: start;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.custom-tab-legend {\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.custom-tab-legend p {\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.custom-tab-image-wrap {\r\n  background: var(--bg-primary);\r\n  border-radius: 8px;\r\n  padding: 0.75rem;\r\n  text-align: center;\r\n}\r\n\r\n.custom-tab-image {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 6px;\r\n}\r\n\r\n.custom-tab-note {\r\n  font-style: italic;\r\n  color: var(--text-tertiary);\r\n}\r\n\r\n.custom-tab-warning {\r\n  background: rgba(245, 158, 11, 0.1);\r\n  border-left: 3px solid var(--warning);\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 8px;\r\n  margin: 0.75rem 0;\r\n}\r\n\r\n.custom-tab-warning p {\r\n  margin: 0;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  line-height: 1.55;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .custom-tab-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .custom-tab-section {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n/* BodySurf guide */\r\n.bodysurf-list {\r\n  margin: 0.5rem 0 0.75rem;\r\n  padding-left: 1.25rem;\r\n  color: var(--text-secondary);\r\n  font-size: 0.95rem;\r\n  line-height: 1.6;\r\n}\r\n\r\n.bodysurf-list li {\r\n  margin-bottom: 0.35rem;\r\n}\r\n\r\n.bodysurf-title-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 0.75rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.bodysurf-title-table th,\r\n.bodysurf-title-table td {\r\n  padding: 0.4rem 0.6rem;\r\n  text-align: left;\r\n  border-bottom: 1px solid var(--border-primary);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.bodysurf-title-table th {\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.bodysurf-title-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.custom-tab-common .guide-inline-link {\r\n  color: var(--accent-primary);\r\n  text-decoration: underline;\r\n  font-weight: 500;\r\n}\r\n\r\n.custom-tab-common .guide-inline-link:hover {\r\n  color: var(--accent-hover);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
